<template>
    <div>
        <el-form label-width="100px">
            <el-form-item label="标题：">
                <el-input v-model="name" size="medium" style="width:75%;" placeholder="请输入标题"></el-input>
            </el-form-item>
            <el-form-item label="信息：">
                <el-input v-model="value" size="medium" style="width:75%;" placeholder="请输入信息"></el-input>
            </el-form-item>
        </el-form>
        <br />
        <div style="text-align:center;">
            <el-button @click.native="cancel" size="medium">返回</el-button>
            <el-button type="primary" size="medium" @click.native="submit">提交</el-button>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                name: '',
                value: ''
            }
        },
        methods: {
            cancel() {
                this.$emit('close')
            },

            submit() {
                if(!this.name || !this.value) {
                    this.$message({
                        showClose: true,
                        duration: 1000,
                        message: '标题和信息不能为空',
                        type: 'warning'
                    })
                    return;
                }
                this.$emit('confirm', {name: this.name, state: true, value: this.value})
            }
        }
    }
</script>

<style>

</style>
